export interface SummaryRow {
  total: number;
}

export const useSummaryController = () => {
  const data: SummaryRow[] = [{ total: NaN }];

  return { data };
};
